export class LevelLink {
  private title: string;
  private route: string;
  private childLevelId: number;
  private parentLevelId: number;
  private dynamic: number;

  constructor (title, route, child, dynamic) {
    this.setTitle(title);
    this.setRoute(route);
    this.setChild(child);
    this.setDynamic(dynamic);
  }
  getTitle(): string {
    return this.title;
  }

  setTitle(value: string) {
    this.title = value;
  }

  getRoute(): string {
    return this.route;
  }

  setRoute(value: string) {
    this.route = value;
  }

  getChild(): number {
    return this.childLevelId;
  }

  setChild(value: number) {
    this.childLevelId = value;
  }

  setDynamic(value: number) {
    this.dynamic = value;
  }

  getDynamic() {
    return this.dynamic;
  }

  getParent = () => {
    return this.parentLevelId;
  }

  // equals = (other: LevelLink): boolean => {
  //   if (this.getChild() === other.getChild() && this.getRoute() === other.getRoute() && this.getTitle() === other.getTitle() ) {
  //    return true;
  //   } else {
  //     return false;
  //   }
  // }

}
